import React, { Component } from 'react';
import axios from "axios";

class ConvertLink extends Component{
  constructor(props){
    super(props);
    this.state = {
      text: props.consultation ? 'Converted': 'Convert into Consultation',
      submitting: props.consultation ? true: false
    };
  };

  render() {
    return(
      <div>
        <button
          onClick={this._handleClick.bind(this)}
          disabled={this.state.submitting}
          className="button is-success">
          { this.state.text }
        </button>
      </div>
    )
  };

  _handleClick() {
    this.setState({ submitting: true })
    axios
      .post('/walk_in_entry_conversion/', { walk_in_entry_id: this.props.id })
      .then((response) => {
        this.setState({ text: "Converted"})
        alert("Success!");
      })
      .catch((response) => {
        this.setState({ text: "Convert into Consultation", submitting: false})
        alert("An error occurred please contact support@prospectwise.com");
      });
  };

}

export default ConvertLink
